import { Component } from '@angular/core';

@Component({
  selector: 'app-home-layout',
  template: `
    <div class="home-layout">
      <app-navbar></app-navbar>
      <div class="home-layout__body">
        <!-- <app-sidebar></app-sidebar> -->
        <div class="route-section">
          <router-outlet></router-outlet>
        </div>
      </div>
      <app-esign-upload-overlay></app-esign-upload-overlay>
    </div>
  `,
  standalone: false,
  styles: [`
    .home-layout {
      display: flex;
      flex-direction: column;
      height: 100vh;
      overflow: hidden;
      background-color: #f0f2f5;
    }
    .home-layout__body {
      display: flex;
      flex: 1;
      overflow: hidden;
    }
    .route-section {
      flex-grow: 1;
      padding: 36px 29px 30px 26px;
      overflow-y: auto;
      background-color: #f0f2f5;
    }
  `]
})
export class HomeLayoutComponent { }
